import produce from 'immer';
import {
  DEFAULT_ACTION,
  SET_CHOICE,
  SET_PLATFORM,
  SET_PLATFORM_OPTIONS,
  GET_INTEGRATION_STATUS,
  GET_INTEGRATION_STATUS_SUCCESS,
  GET_INTEGRATION_STATUS_FAILURE,
  UPDATE_INTEGRATION_STATUS_SUCCESS,
} from './constants';
import { steps } from './util/steps';

export const initialState = {
  choice: null,
  platform: null,
  platformOption: null,
  integrationData: [],
  steps, 
  loading: false,
  error: null,
};

/* eslint-disable default-case, no-param-reassign */
const checkoutJourneyReducer = (
  state = initialState,
  action,
) =>
  produce(state, draft => {
    switch (action.type) {
      case SET_CHOICE:
        draft.choice = action.payload;
        draft.platform = null
        draft.platformOption = null
        break;

      case SET_PLATFORM:
        draft.platform = action.payload;
        break;

      case SET_PLATFORM_OPTIONS:
        draft.platformOption = action.payload;
        break;

      case GET_INTEGRATION_STATUS:
        if (!draft.loading) {
          draft.loading = true;
          draft.error = null;
        }
        break;

     case GET_INTEGRATION_STATUS_SUCCESS:
        draft.loading = false;
        draft.integrationData = action.payload || [];
        draft.error = null;
        // Create a map for faster lookup
        const statusMap = {};
        if (Array.isArray(action.payload)) {
          action.payload.forEach(item => {
            statusMap[item.step] = item.status;
          });
        }
        
        // Update the steps using the map
        draft.steps = draft.steps.map(step => ({
          ...step,
          subSteps: step.subSteps.map(subStep => {
            // Check if this step exists in the API response
            if (subStep.id in statusMap) {
              return { ...subStep, isComplete: statusMap[subStep.id] };
            }
            return subStep;
          }),
        }));
        break;

      case GET_INTEGRATION_STATUS_FAILURE:
        draft.loading = false;
        draft.integrationData = [];
        draft.error = action.error || 'Something went wrong';
        break;

      case UPDATE_INTEGRATION_STATUS_SUCCESS:
        draft.steps = draft.steps.map(step => ({
          ...step,
          subSteps: step.subSteps.map(subStep =>
            subStep.id === action?.payload?.step
              ? { ...subStep, isComplete: action.payload.status }
              : subStep,
          ),
        }));
        break;

      case DEFAULT_ACTION:
        break;
    }
  });

export default checkoutJourneyReducer;